import axios from 'axios'
import { getAPIUrl } from '../API'
import { v4 as uuid } from 'uuid'

export interface SearchStreetOwnersListRequest {
  streetName: string
  region: string
  suburb: string
}

export interface StreetOwnerResponse {
  uuid: string
  cmaid: number
  erfNo: string
  streetNo: string
  address: string
  schemeName: string
  street: string
  owner: string
  ownerIDNo: string
  erfExtent: number
  erfUsage: string
}

export const searchStreetOwnersList: (
  options: SearchStreetOwnersListRequest,
) => Promise<StreetOwnerResponse[]> = async (options) => {
  const { data } = await axios.post(
    `${getAPIUrl()}/BridgingFinance/streetownerslist`,
    options,
    {
      headers: {
        Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
      },
    },
  )
  return (data.data as StreetOwnerResponse[]).map((item) => ({
    ...item,
    uuid: uuid(),
  }))
}
